import * as React from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import {
  OverviewSubtitle,
  OverviewTitle,
  OverviewTitleWithSubtitleWrapper,
  OverviewTitleWrapper,
} from "../../components/Details/OverviewInfo/styles";
import PlainForm from "../../components/Forms/User/PlainForm";
import OverlaySpinner from "../../components/Loaders/OverlaySpinner";
import {
  BareLayoutTitleWrapper,
  BareLayoutWrapper,
  DetailPageBox,
} from "../../components/sharedStyles";
import { destroyForm, updateActiveFormInstance } from "../../store/base";
import { useUser, constants } from "../../store/users";
import PageTitle from "../Layouts/PageTitle/PageTitle";

export default () => {
  const dispatch = useDispatch();
  const { userId } = useParams();
  const [user] = useUser(userId);

  React.useEffect(() => {
    if (user) {
      dispatch(
        updateActiveFormInstance({
          storeName: constants.STORE_NAME,
          data: user,
        })
      );
    }
  }, [user]);

  React.useEffect(() => {
    return () => {
      dispatch(
        destroyForm({
          constants,
          method: "PATCH",
        })
      );
    };
  }, []);

  const breadCrumbs = [
    {
      label: "Inställningar",
      url: "/account/user",
    },
    {
      label: "Användare & Grupper",
      url: "/account/groups-and-users",
    },
    {
      label: user?.str_representation || "Laddar...",
      url: `/account/groups-and-users/user/${user?.id}`,
    },
    {
      label: "Redigera",
    },
  ];

  if (!user)
    return (
      <DetailPageBox style={{ height: "600px" }}>
        <OverlaySpinner />
      </DetailPageBox>
    );

  return (
    <BareLayoutWrapper>
      <BareLayoutTitleWrapper>
        <PageTitle dark title="Redigera användare" breadCrumbs={breadCrumbs} />
      </BareLayoutTitleWrapper>
      <DetailPageBox>
        <OverviewTitleWrapper>
          <OverviewTitleWithSubtitleWrapper>
            <OverviewTitle>Redigera användare</OverviewTitle>
            <OverviewSubtitle>
              Tryck på "Uppdatera" för att spara ändringar
            </OverviewSubtitle>
          </OverviewTitleWithSubtitleWrapper>
        </OverviewTitleWrapper>
        <PlainForm
          method="PATCH"
          untouchedInstance={user}
          nextUrl={`/account/groups-and-users/user/${user?.id}`}
        />
      </DetailPageBox>
    </BareLayoutWrapper>
  );
};
